
import React, { useState, useEffect } from "react";
import axiosInstance from '../axiosConfig';
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import { Link } from "react-router-dom";
import "../styles.css";

const ArRequest = () => {
  const [userData, setUserData] = useState(null);
  const [selectedAttendanceId, setSelectedAttendanceId] = useState('');  
  const [regularizationDate, setRegularizationDate] = useState('');
  const [inDate, setInDate] = useState('');
  const [inTime, setInTime] = useState('');
  const [outDate, setOutDate] = useState('');
  const [outTime, setOutTime] = useState('');
  const [totalTime, setTotalTime] = useState('');
  const [reason, setReason] = useState('');
  const [approver, setApprover] = useState({});
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isIdCardPopupVisible, setIsIdCardPopupVisible] = useState(false);

  const currentUserId = localStorage.getItem('id');

  useEffect(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 520) {
      setIsSidebarVisible(false);
    } else {
      setIsSidebarVisible(true);
    }
  }, []);

  const handleToggleClick = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  useEffect(() => {
    if (currentUserId) {
      axiosInstance.get(`/user/${currentUserId}/`)
        .then((response) => setUserData(response.data))
        .catch((error) => console.error('Error fetching user data:', error));
    }
  }, [currentUserId]);

  useEffect(() => {
    axiosInstance.get(`/assign-manager/${currentUserId}/`)
      .then((response) => setApprover(response.data))
      .catch((error) => console.error('Error fetching approver data:', error));
  }, [currentUserId]);

  useEffect(() => {
    if (inTime && outTime && inDate === outDate) {
      const inTimeDate = new Date(`${inDate}T${inTime}`);
      const outTimeDate = new Date(`${outDate}T${outTime}`);
      const diff = (outTimeDate - inTimeDate) / (1000 * 3600); 
      setTotalTime(diff.toFixed(2)); 
    } else {
      setTotalTime('');
    }
  }, [inDate, inTime, outDate, outTime]);

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    if (error) setError(null);
    if (success) setSuccess(null);
  };

  const handleARRequestSubmit = () => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);
    
    const arRequestData = {
      attendance_id: selectedAttendanceId,
      regularization_date: regularizationDate, 
      in_date: inDate,
      in_time: inTime,
      out_date: outDate,
      out_time: outTime,
      reason: reason,
    };

    axiosInstance.post(`/attendance/regularize/`, arRequestData)
      .then((response) => {
        setSuccess('Attendance Regularization Request submitted successfully!');
        // Reset form
        setRegularizationDate('');
        setInDate('');
        setInTime('');
        setOutDate('');
        setOutTime('');
        setTotalTime('');
        setReason('');
      })
      .catch((error) => {
        setError('Error submitting AR Request. Please try again.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const menuItems = [
    { icon: '&#127968;', label: 'Dashboard', path: '/user-dashboard' },
    { icon: '&#128100;', label: 'My Profile', path: `/user-profile/${userData?.id}` },
    { icon: '&#128197;', label: 'Attendance', path: `/leave-attendance/${userData?.id}` },
    { icon: '&#128203;', label: 'Leave Management', path: `/leave-management/${userData?.id}` },
    // { icon: '&#128197;', label: 'Calendar', path: '/calendar', condition: userData?.role_name === 'employee' },
    { icon: '&#9998;', label: 'Create AR Request', path: `/ar-request/${userData?.id}` },
    { icon: '&#128200;', label: 'My Calendar', path: '/my-calendar' },
    { icon: '&#128202;', label: 'AR Transactions', path: '/ar-transaction/' },
    // { icon: '&#128178;', label: 'Payroll', path: 'https://hrms.teamhalt.com/', active: false },
    { icon: '&#128179;', label: 'ID Card', action: () => setIsIdCardPopupVisible(true) },
  ];

  const profilePhotoUrl = userData?.profile_photo?.startsWith('http://')
  ? userData?.profile_photo.replace('http://', 'https://') 
  : userData?.profile_photo;

  return (
    <div className="dashboard-wrapper">
      <Header 
        onToggleClick={handleToggleClick} 
        isSidebarVisible={isSidebarVisible} 
      />
      
      <Sidebar 
        isSidebarVisible={isSidebarVisible}
        currentUser={userData}
        menuItems={menuItems}
        handleLogout={handleLogout}
      />
      
      <div className={`dashboard-main-content ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="ar-request-container">
          <div className="ar-request-header">
            <h1>AR Request</h1>
            <p>Create an Attendance Regularization Request</p>
          </div>
          
          <div className="ar-request-card">
            {error && (
              <div className="ar-error-message">
                <span>⚠</span> {error}
              </div>
            )}
            
            {success && (
              <div className="ar-success-message">
                <span>✓</span> {success}
              </div>
            )}
            
            <div className="ar-form-section">
              <div className="ar-form-group">
                <label>Regularization Date</label>
                <input
                  type="date"
                  className="ar-input"
                  value={regularizationDate} 
                  onChange={handleInputChange(setRegularizationDate)}
                />
              </div>
            </div>
            
            <div className="ar-time-grid">
              <div className="ar-form-group">
                <label>In Date</label>
                <input
                  type="date"
                  className="ar-input"
                  value={inDate}
                  onChange={handleInputChange(setInDate)}
                />
              </div>
              <div className="ar-form-group">
                <label>In Time</label>
                <input
                  type="time"
                  className="ar-input"
                  value={inTime}
                  onChange={handleInputChange(setInTime)}
                />
              </div>
              <div className="ar-form-group">
                <label>Out Date</label>
                <input
                  type="date"
                  className="ar-input"
                  value={outDate}
                  onChange={handleInputChange(setOutDate)}
                />
              </div>
              <div className="ar-form-group">
                <label>Out Time</label>
                <input
                  type="time"
                  className="ar-input"
                  value={outTime}
                  onChange={handleInputChange(setOutTime)}
                />
              </div>
            </div>
            
            <div className="ar-form-section">
              <div className="ar-form-group">
                <label>Total Time (hours)</label>
                <input
                  type="text"
                  className="ar-input ar-input-disabled"
                  value={totalTime}
                  disabled
                  placeholder="Auto-calculated"
                />
              </div>
            </div>
            
            <div className="ar-form-section">
              <div className="ar-form-group">
                <label>Reason For Not Punching</label>
                <textarea
                  className="ar-textarea"
                  value={reason}
                  onChange={handleInputChange(setReason)}
                  placeholder="Enter reason for regularization..."
                  rows={4}
                />
              </div>
            </div>
            
            <div className="ar-form-section">
              <div className="ar-form-group">
                <label>Approver</label>
                <input
                  type="text"
                  className="ar-input ar-input-disabled"
                  value={approver.manager_name || 'Loading...'}
                  disabled
                />
              </div>
            </div>
            
            <div className="ar-form-actions">
              <button 
                className="ar-submit-btn" 
                type="button" 
                onClick={handleARRequestSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="ar-loading-spinner"></span>
                ) : (
                  <>
                    <span>📤</span> Submit Request
                  </>
                )}
              </button>
              <Link to="/user-dashboard" className="ar-cancel-btn">
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* ID Card Popup */}
      {isIdCardPopupVisible && (
        <div className="id-card-overlay" onClick={() => setIsIdCardPopupVisible(false)}>
          <div className="id-card-popup" onClick={(e) => e.stopPropagation()}>
            <button className="id-card-close" onClick={() => setIsIdCardPopupVisible(false)}>×</button>
            
            <div className="id-card-header">
              <img src="/Teamhalt.png" alt="Logo" className="id-card-logo" />
              <span>TEAMHALT PRIVATE LIMITED</span>
            </div>
            
            <div className="id-card-body">
              <div className="id-card-profile">
                <img
                  src={profilePhotoUrl || '/profile.jpg'}
                  alt="Profile"
                  className="id-card-photo"
                />
                <div className="id-card-info">
                  <h4>{userData?.first_name} {userData?.last_name}</h4>
                  <p className="id-designation">{userData?.designation}</p>
                  <div className="id-dob">
                    <strong>DOB:</strong>
                    <span>
                      {userData?.date_of_birth
                        ? new Date(userData.date_of_birth).toLocaleDateString("en-GB").replace(/\//g, "-")
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </div>
              
              <hr className="id-card-divider" />
              
              <div className="id-card-details">
                {[
                  { label: "Emp ID", value: userData?.employee_code },
                  { label: "Department", value: userData?.department },
                  { label: "ESIC No.", value: userData?.esic_no },
                  { label: "UAN No.", value: userData?.uan_no },
                  { label: "Gender", value: userData?.gender },
                  { label: "Contact No.", value: userData?.contact_number },
                ].map((item, idx) => (
                  <div key={idx} className="detail-row">
                    <strong>{item.label}:</strong>
                    <span>{item.value || "N/A"}</span>
                  </div>
                ))}
              </div>
              
              {typeof userData?.work_location_name === "string" &&
                userData.work_location_name.toLowerCase() !== "noida" && (
                <div className="id-card-duty">
                  <strong>On Contractual Duty Of:</strong>
                  <span>{userData?.duty_of || "N/A"}</span>
                </div>
              )}
              
              <div className="id-card-footer">
                https://teamhalt.com/
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArRequest;

